import React, { FC } from 'react';
import Header from './Header';
import Footer from './Footer';

interface ILayoutProps{
    children: React.ReactNode
}

const Layout: FC<ILayoutProps> = ({children}) =>{
  return (
    <div className="layout">
        <Header/>
        <div>{children}</div>
        <Footer/>
    </div>
  );
}

export default Layout;
